import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Notifications from "./Notifications";

const Navbar = ({ isMobile, darkMode, handleLogout }) => {
  const [hamburgerOpen, setHamburgerOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const [profile, setProfile] = useState(() =>
    typeof window !== "undefined" ? localStorage.getItem("profile") : null
  );

  useEffect(() => {
    const onStorage = () => setProfile(localStorage.getItem("profile"));
    window.addEventListener("storage", onStorage);
    const interval = setInterval(() => {
      try {
        const p = localStorage.getItem("profile");
        setProfile((prev) => (prev !== p ? p : prev));
      } catch (e) {}
    }, 500);
    return () => {
      window.removeEventListener("storage", onStorage);
      clearInterval(interval);
    };
  }, []);

  const toggleHamburgerMenu = () => setHamburgerOpen(!hamburgerOpen);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar position="static">
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0 16px",
          flexWrap: "wrap",
        }}
      >
        <Link
          to="/code-analysis"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <Typography variant="h6">CodeFort</Typography>
        </Link>

        {!isMobile && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flex: 1,
              gap: "24px",
              flexWrap: "wrap",
            }}
          >
            <Button color="inherit" component={Link} to="/export-results">
              Exportar Resultados
            </Button>
            <Button color="inherit" component={Link} to="/history">
              Histórico de Análises
            </Button>
            <Button color="inherit" component={Link} to="/automation">
              Automação de Testes
            </Button>
            <Button color="inherit" component={Link} to="/unit-tests">
              Testes Unitários
            </Button>
            {profile === "Administrador" && (
              <Button color="inherit" component={Link} to="/admin-dashboard">
                Dashboard Admin
              </Button>
            )}
          </Box>
        )}

        {/* Área de Ícones */}
        <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
          {/* Ícone de Notificações */}
          <Notifications />

          <IconButton
            color="inherit"
            onClick={handleMenuOpen}
            aria-controls="profile-menu"
            aria-haspopup="true"
          >
            <AccountCircleIcon />
          </IconButton>
        </Box>

        <Menu
          id="profile-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          <MenuItem
            component={Link}
            to="/general-config"
            onClick={handleMenuClose}
          >
            Configurações
          </MenuItem>
          <MenuItem onClick={() => navigate("/profile")}>Perfil</MenuItem>
          <MenuItem
            onClick={() => {
              handleLogout();
              handleMenuClose();
            }}
          >
            Logout
          </MenuItem>
        </Menu>
      </Toolbar>

      {isMobile && (
        <Box className="hamburger-menu">
          <Button color="inherit" onClick={toggleHamburgerMenu}>
            ☰
          </Button>
          {hamburgerOpen && (
            <Box
              style={{
                position: "absolute",
                top: "56px",
                left: "0",
                width: "100%",
                background: darkMode ? "#121212" : "#ffffff",
                color: darkMode ? "#ffffff" : "#000000",
                zIndex: "1000",
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                display: "flex",
                flexDirection: "column",
                padding: "16px",
              }}
            >
              <Button
                color="inherit"
                component={Link}
                to="/export-results"
                onClick={toggleHamburgerMenu}
                style={{
                  justifyContent: "flex-start",
                  textAlign: "left",
                  color: darkMode ? "#ffffff" : "#000000",
                }}
              >
                Exportar Resultados
              </Button>
              <Button
                color="inherit"
                component={Link}
                to="/history"
                onClick={toggleHamburgerMenu}
                style={{
                  justifyContent: "flex-start",
                  textAlign: "left",
                  color: darkMode ? "#ffffff" : "#000000",
                }}
              >
                Histórico de Análises
              </Button>
              <Button
                color="inherit"
                component={Link}
                to="/automation"
                onClick={toggleHamburgerMenu}
                style={{
                  justifyContent: "flex-start",
                  textAlign: "left",
                  color: darkMode ? "#ffffff" : "#000000",
                }}
              >
                Automação de Testes
              </Button>
              <Button
                color="inherit"
                component={Link}
                to="/unit-tests"
                onClick={toggleHamburgerMenu}
                style={{
                  justifyContent: "flex-start",
                  textAlign: "left",
                  color: darkMode ? "#ffffff" : "#000000",
                }}
              >
                Testes Unitários
              </Button>
              {profile === "Administrador" && (
                <Button
                  color="inherit"
                  component={Link}
                  to="/admin-dashboard"
                  onClick={toggleHamburgerMenu}
                  style={{
                    justifyContent: "flex-start",
                    textAlign: "left",
                    color: darkMode ? "#ffffff" : "#000000",
                  }}
                >
                  Dashboard Admin
                </Button>
              )}
            </Box>
          )}
        </Box>
      )}
    </AppBar>
  );
};

export default Navbar;
